export default "__VITE_ASSET__r$acVz03__"